var _defs, _rect, _path, _path2, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgMidnightFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 720,
    viewBox: "0 0 1280 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(640 360) rotate(90) scale(460 720)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B6177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111C28"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 16,
    stdDeviation: 20,
    floodColor: "#020617",
    floodOpacity: 0.38
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 720,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 92L164 256H214L50 92H0Z",
    fill: "#637A93",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 128L128 256H174L46 128H0Z",
    fill: "#2E3E52",
    fillOpacity: 0.88
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M844 0L1040 196L1086 150L936 0H844Z",
    fill: "#8CA5C2",
    fillOpacity: 0.78
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908 0L1114 206L1148 172L976 0H908Z",
    fill: "#41546B",
    fillOpacity: 0.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986 0L1198 212L1234 176L1056 0H986Z",
    fill: "#26374A",
    fillOpacity: 0.92
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 574L148 720H202L54 574H0Z",
    fill: "#7B90A9",
    fillOpacity: 0.78
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 496L296 720H352L128 496H72Z",
    fill: "#233144",
    fillOpacity: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 572L488 720H530L382 572H340Z",
    fill: "#90A8C4",
    fillOpacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgMidnightFrame);
export default __webpack_public_path__ + "static/media/bg-midnight-frame.e46f28d7d55f6621d30c4ef7ef30cef4.svg";
export { ForwardRef as ReactComponent };